import { BUCLOUD_SERVER_URL } from '../config';

export async function getPropertyEngrainMap(propertyId: string) {
  try {
    const response = await fetch(`${BUCLOUD_SERVER_URL}/engrain/property/map`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ opaque_property_id: propertyId })
    });

    if (response.ok) {
      return await response.json();
    }

    return null;
  } catch (error) {
    console.log('error', error);
    return null;
  }
}
